import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import Modal from "react-modal";

import { toast } from "react-toastify";

const GoodsReturnInvoiceForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "10%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "900px",
      maxHeight: "auto",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const frmRef = useRef({});

  const [subTotalAmount, setSubTotal] = useState(0);
  const [taxs, setTaxs] = useState();
  const [currancys, setCurrancys] = useState();
  const [discountPr, setDiscountPr] = useState(0);
  const [discountAmt, setDiscountAmt] = useState(0);
  const [totalAmt, setTotalAmt] = useState(0);
  const [frieghtCharges, setfrieghtCharges] = useState(0);

  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);
  const [vendorId, setVendorId] = useState(0);

  const [docurl, setDocUrl] = useState(false);
  const [selectedReceiptId, setSelectedReceiptId] = useState([]);
  const [returnReceiptId, setReturnReceiptId] = useState([]);
  const [returnReceiptData, setReturnReceiptData] = useState([]);

  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { sendRequest: postGoodsReturnInvoice } = useHttp();

  const { sendRequest: getGoodsReceipt } = useHttp();
  const { sendRequest: getGoodsReceiptId } = useHttp();

  const { sendRequest: getGoodsReturnData } = useHttp();

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeeData(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getTaxs } = useHttp();
  const { sendRequest: getCurrency } = useHttp();

  useEffect(() => {
    getCurrency(
      {
        url: `/api/currencies/`,
      },
      (res) => {
        if (res) {
          setCurrancys(res);
        }
      }
    );
  }, [getCurrency]);

  useEffect(() => {
    getTaxs(
      {
        url: `/api/tax/`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setTaxs(res);
        }
      }
    );
  }, [getTaxs]);

  useEffect(() => {
    getGoodsReceiptId(
      {
        url: `/api/goodsReturnReciept/?invoice=${true}&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        const datas = res.output;

        setReturnReceiptId(res.output);
        //console.log("setReturnReceiptId", res);
      }
    );
  }, [getGoodsReceiptId]);
  const submitHandler = (e) => {
    e.preventDefault();

    setLoading(true);
    const data = {
      invoiceDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),

      goodsReturnId: frmRef.current.goods_return_receipt_id.value,
      vendorId: vendorId,
      currencyId: frmRef.current.currency.value,
      // bankDetails: bankDetails,
      supervisorEmployeeId: employeeId,
      productDetails: productDetails,
      lineTotalAmount: parseFloat(subTotalAmount),
      discountPercentage: parseFloat(discountPr),
      discountAmount: parseFloat(discountAmt),
      totalAmount: parseFloat(totalAmt),
      freightCharges: parseFloat(frieghtCharges),
      taxId: frmRef.current.tax.value,
      taxAmount: parseFloat(frmRef.current.tax_amt.value),
      totalPurchaseAmount: parseFloat(frmRef.current.total_cost.value),
      amountChargeable: frmRef.current.amt_chargeable.value,
      itemCondition: frmRef.current.condition.value,
      returnReason: frmRef.current.reason.value,
      remark: frmRef.current.remark.value,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      serviceId: props.sId,
    };
    if (props.update) {
      data["goodsReturnInvoiceId"] = props.update.goodsReturnInvoiceId;
    }

    postGoodsReturnInvoice(
      {
        url: "/api/goodsReturnInvoice/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        props.addForm(false);
        toast.success("Good Return Invoice added");
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );

    //console.log(data);
  };

  useEffect(() => {
    if (props.update) {
      frmRef.current.date.value = moment(props.update.Date).format(
        "YYYY-MM-DD"
      );
      frmRef.current.receipt_date.value = moment(
        props.update.goodRecieptDate
      ).format("YYYY-MM-DD");
      frmRef.current.goods_receipt_id.value = props.update.goodsRecieptId;
      frmRef.current.goods_return_receipt_id =
        props.update.goodsReturnRecieptId;
      frmRef.current.purchase_order_id = props.update.purchaseorderId;
      frmRef.current.contact_person_name.value = props.update.contactPersonName;
      frmRef.current.work_contact.value = props.update.contactWork;
      frmRef.current.whatsapp_contact.value = props.update.whatsapp;
      frmRef.current.email.value = props.update.email;
      frmRef.current.vendor_name.value = props.update.vendorName;
      frmRef.current.vendor_id.value = props.update.vendorCode;
      frmRef.current.total_amt.value = props.update.totalAmount;
      frmRef.current.tax.value = props.update.tax;
      frmRef.current.tax_amt.value = props.update.taxAmount;
      frmRef.current.total_cost.value = props.update.totalPurchase;
      frmRef.current.amt_chargeable.value = props.update.amountChargeable;
      frmRef.current.remark.value = props.update.remark;
      frmRef.current.condition.value = props.update.itemCondition;
      frmRef.current.reason.value = props.update.returnReason;
      setProductDetails(props.update.productDetails);
    }
  }, [props.update]);

  const handleIdChange = (e) => {
    frmRef.current.vendor_id.value = "";
    frmRef.current.vendor_name.value = "";
    frmRef.current.contact_person_name.value = "";
    frmRef.current.work_contact.value = "";
    frmRef.current.whatsapp_contact.value = "";
    frmRef.current.email.value = "";

    setProductDetails([])

    const filteredData =
      returnReceiptId &&
      returnReceiptId
        .filter(
          (item) =>
            parseInt(item.goodsReturnRecieptId) === parseInt(e.target.value)
        )
        .map((item) => item);

    // //console.log("filteredData", filteredData);
    setReturnReceiptData(filteredData);

    getGoodsReturnData(
      {
        url: `/api/GoodsReturnProductForRI/?orgId=${localStorage.getItem(
          "orgId"
        )}&goodsReturnId=${
          filteredData[0] && filteredData[0].goodsReturnRecieptId
        }`,
      },
      (res) => {
        var i = 1;
        res.output.forEach((item) => {
          item.lineSrNo = i;
          i++;
        });

        setProductDetails(res.output);
      }
    );

    frmRef.current.vendor_id.value =
      (filteredData[0] && filteredData[0].vendorCode) || "";
    setVendorId(filteredData[0] && filteredData[0].vendorId);

    frmRef.current.tax.value = (filteredData[0] && filteredData[0].taxId) || 0;
    frmRef.current.tax_amt.value =
      (filteredData[0] && filteredData[0].taxAmount) || 0;
    frmRef.current.total_amt.value =
      (filteredData[0] && filteredData[0].totalAmount) || 0;
    frmRef.current.total_cost.value =
      (filteredData[0] && filteredData[0].totalPurchaseAmount) || 0;
    frmRef.current.reason.value =
      (filteredData[0] && filteredData[0].returnReason) || "";
    frmRef.current.remark.value =
      (filteredData[0] && filteredData[0].remark) || "";
    frmRef.current.amt_chargeable.value =
      (filteredData[0] && filteredData[0].amountChargeable) || "";
    frmRef.current.condition.value =
      (filteredData[0] && filteredData[0].itemCondition) || "";
    loadVendorData((filteredData[0] && filteredData[0].vendorId) || 0);
    setSubTotal((filteredData[0] && filteredData[0].lineTotalAmount) || 0);
    setDiscountPr((filteredData[0] && filteredData[0].discountPercentage) || 0);
    setDiscountAmt(filteredData[0] && filteredData[0].discountAmount);
    setTotalAmt(
      filteredData[0] &&
        filteredData[0].lineTotalAmount - filteredData[0].discountAmount
    );
    setfrieghtCharges((filteredData[0] && filteredData[0].freightCharges) || 0);
  };

  const { sendRequest: getLoadVendor } = useHttp();

  const loadVendorData = (id) => {
    if (id) {
      getLoadVendor(
        {
          url: `/api/addVendor/?vendorId=${id}`,
        },
        (res) => {
          console.log(res);
          if (res) {
            frmRef.current.vendor_id.value = res.vendorCode || "";
            frmRef.current.vendor_name.value = res.vendorName || "";
            frmRef.current.contact_person_name.value =
              res.contactPersonName || "";
            frmRef.current.work_contact.value = res.contactWork || "";
            frmRef.current.whatsapp_contact.value = res.whatsapp || "";
            frmRef.current.email.value = res.email || "";
          }
        }
      );
    }
  };

  return (
    <>
      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>

          <table className="table table-responsive table-bordered ">
            <thead>
              <tr className="">
                <th>Sr. No</th>
                <th>Item Description</th>
                <th>Item Type</th>
                <th>Item Category/Variety</th>
                <th>Item Unit Price</th>
                <th>Rate</th>
                <th>Item Quantity</th>
                <th>Unit</th>
                <th>Amount</th>
              </tr>
            </thead>

            <tbody>
              {productDetails &&
                productDetails.map((itm, i) => {
                  // //console.log(productDetails);
                  return (
                    <tr key={i}>
                      <td>{itm.linesrno}</td>

                      <td>{itm.productName}</td>
                      <td>{itm.productTypeName}</td>
                      <td>{itm.productSubTypeName}</td>
                      <td>{itm.itemUnitPrice}</td>
                      <td>{itm.rate}</td>
                      <td>{itm.goodsReturnQuantity}</td>
                      <td>{itm.unitAbbreviation}</td>
                      <td>{itm.rate * itm.goodsReturnQuantity}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <hr />
          <div className="row">
            <div className="col-md-3">
              <label htmlFor={"subTotalAmount"}>Sub-total Amount</label>
              <input
                type={"number"}
                id={"subTotalAmount"}
                value={subTotalAmount}
                ref={(el) => (productRef.current["subTotalAmount"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"discount"}>Discount%</label>
              <input
                type={"number"}
                id={"discount"}
                required
                value={discountPr}
                ref={(el) => (productRef.current["discount"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"discountAmount"}>Discounted Amount</label>
              <input
                type={"number"}
                id={"discountAmount"}
                required
                value={discountAmt}
                disabled
                ref={(el) => (productRef.current["discountAmount"] = el)}
                className="form-control"
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"totalAmount"}>Total Amount</label>
              <input
                type={"input"}
                id={"totalAmount"}
                required
                disabled
                value={totalAmt}
                ref={(el) => (productRef.current["totalAmount"] = el)}
                className="form-control"
              />
            </div>
          </div>

          <div className="text-center mt-2">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                productDetails.map((x) => (x["isSave"] = true));
                setClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            &nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Good Return Invoice Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"date"}> {"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />{" "}
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"vendor_name"}>
                        {" "}
                        {"Assign Employee"}
                      </label>
                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={employeeId}
                        required
                        onChange={(e) => {
                          setEmployeeId(e.target.value);
                        }}
                      >
                        {/* {employeeId &&
                    employeeId.map((x) => <option value={x}>{x}</option>)}
                */}
                        <option value="">select</option>
                        {employeeData &&
                          employeeData.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                              selected={
                                props.update &&
                                x.empId === props.update.supervisorEmployeeId
                              }
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"goods_return_receipt_id"}>
                        {" "}
                        {"Goods Return  No"}
                      </label>
                      <select
                        id="goods_return_receipt_id"
                        className="form-control dropdowns"
                        ref={(el) =>
                          (frmRef.current["goods_return_receipt_id"] = el)
                        }
                        onChange={handleIdChange}
                      >
                        <option value="0">select</option>
                        {returnReceiptId &&
                          returnReceiptId.map((x, i) => (
                            <option key={i} value={x.goodsReturnRecieptId}>
                              {x.docNo}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"vendor_name"}> {"Vendor Name"}</label>
                      <input
                        type={"text"}
                        disabled
                        id="vendor_name"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["vendor_name"] = el)}
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"vendor_id"}> {"Vendor Code"}</label>
                      <input
                        type={"text"}
                        id={"vendor_id"}
                        required
                        ref={(el) => (frmRef.current["vendor_id"] = el)}
                        className="form-control"
                        readOnly
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"contact_person_name"}>
                        {" "}
                        {"Contact Person Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"contact_person_name"}
                        required
                        ref={(el) =>
                          (frmRef.current["contact_person_name"] = el)
                        }
                        className="form-control"
                        readOnly
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"email"}> {"Email Id"}</label>
                      <input
                        type={"email"}
                        id={"email"}
                        readOnly
                        required
                        ref={(el) => (frmRef.current["email"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"work_contact"}>
                        {"Contact Number(work)"}
                      </label>
                      <input
                        type={"text"}
                        id={"work_contact"}
                        required
                        ref={(el) => (frmRef.current["work_contact"] = el)}
                        className="form-control"
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"whatsapp_contact"}>
                        {"Contact Number(whatsapp)"}
                      </label>
                      <input
                        type={"text"}
                        id={"whatsapp_contact"}
                        required
                        ref={(el) => (frmRef.current["whatsapp_contact"] = el)}
                        className="form-control"
                        readOnly
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"text"}
                        id={"product_details"}
                        autoComplete="off"
                        onClick={(e) => {
                          e.preventDefault();
                          // productDetails &&
                          //   setProductDetails((items) => items.filter((x) => x.isSave));
                          setClose(true);
                        }}
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn  btn-sm btn-success"
                      >
                        view
                      </button>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"total_amt"}>{"Total Amount"}</label>
                      <input
                        type={"text"}
                        id={"total_amt"}
                        required
                        readOnly
                        ref={(el) => (frmRef.current["total_amt"] = el)}
                        className="form-control"
                        value={totalAmt}
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"tax"}> {"Tax"}</label>
                      <select
                        id="tax"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["tax"] = el)}
                        readOnly
                      >
                        <option value="">Select</option>
                        {taxs &&
                          taxs.map((x) => (
                            <option key={x.taxId} value={x.taxId}>
                              {x.taxName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"tax_amt"}>{"Tax Amount"}</label>
                      <input
                        type={"text"}
                        id={"tax_amt"}
                        required
                        ref={(el) => (frmRef.current["tax_amt"] = el)}
                        className="form-control"
                        readOnly
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"frieght_charges"}>
                        {"Frieght Charges"}
                      </label>
                      <input
                        type={"text"}
                        id={"frieght_charges"}
                        required
                        // ref={(el) => (frmRef.current["frieght_charges"] = el)}
                        value={frieghtCharges}
                        onChange={(e) => setfrieghtCharges(e.target.value)}
                        className="form-control currancy-value"
                        readOnly
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"currency"}> {"Currency"}</label>
                      <select
                        id="currency"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["currency"] = el)}
                        readOnly
                      >
                        {currancys &&
                          currancys.map((x) => (
                            <option key={x.currencyId} value={x.currencyId}>
                              {x.country.currencyName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"total_cost"}>
                        {"Total Purchase Cost/Value"}
                      </label>
                      <input
                        type={"text"}
                        id={"total_cost"}
                        required
                        ref={(el) => (frmRef.current["total_cost"] = el)}
                        className="form-control"
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"amt_chargeable"}>
                        {" "}
                        {"Amount Chargeable"}
                      </label>
                      <input
                        type={"text"}
                        id={"amt_chargeable"}readOnly
                        required
                        ref={(el) => (frmRef.current["amt_chargeable"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"condition"}>
                        {" "}
                        {"Condition of Item"}
                      </label>

                      <input
                        type={"text"}
                        id={"condition"}
                        required
                        ref={(el) => (frmRef.current["condition"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"reason"}>{"Reason of Return"}</label>
                      <input
                        type={"text"}
                        id={"reason"}
                        required
                        ref={(el) => (frmRef.current["reason"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        required
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className=" text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default GoodsReturnInvoiceForm;
